import type { ReactNode } from "react";
import { AppIcon } from "@/v2/lib/appIcons";
import { BillableIcon } from "../BillableIcon";
import type { Entry } from "../normalize";
import { StatusIcon } from "../StatusIcon";
import type { EnumFilterField } from "./types";

/** Small dot/icon prefix shown before a value in chips and pickers. */
export function valueDecoration(
	field: EnumFilterField,
	value: string,
): ReactNode | undefined {
	if (field === "status") {
		return (
			<StatusIcon status={value as Entry["status"]} className="size-3.5" />
		);
	}
	if (field === "billableCategory") {
		return (
			<BillableIcon
				category={value as Entry["billableCategory"]}
				className="size-3.5"
			/>
		);
	}
	if (field === "application") {
		return (
			<AppIcon application={value} className="size-3.5 shrink-0 text-muted-foreground" />
		);
	}
	return undefined;
}
